import React, { useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import ServicesField from "./ServicesField";

const ServiceModal = ({ isOpen, onClose, rowData, church }) => {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = isOpen ? "hidden" : prev;
    return () => (document.body.style.overflow = prev);
  }, [isOpen]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex justify-end items-center ${
        isOpen ? "" : "pointer-events-none"
      }`}
    >
      <div
        onClick={onClose}
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
      />

      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative bg-[#1f1f1f] text-white shadow-2xl transition-all duration-500 rounded-md ${
          isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        }`}
        style={{ width: "85%", height: "90%" }}
      >
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          <h2 className="text-lg font-semibold">
            {rowData ? "Edit Service" : "Add Service"}
          </h2>
          <button onClick={onClose} className="p-1">
            <IoCloseOutline className="text-2xl" />
          </button>
        </div>

        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">
          <ServicesField church={church} rowData={rowData} onClose={onClose} />
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;
